import Loading from '@/common/components/Loading';
import { useContext } from 'react';
import Daily from './Daily';
import Talking from '../talking/Talking';
import { CustomerDataContext } from '@/common/components/layout/productLayout/context/CustomerDataContext';

const DailyWrapper = () => {
	const { userData: user } = useContext(CustomerDataContext);

	if (!user) {
		return <Loading />;
	}

	return <>{user && user.showDailyVersionV2 ? <Daily /> : <Talking />}</>;
};

export default DailyWrapper;
